import axios from '@/libs/axios'


export const saveHiddenWidgets = (data) => {

   // console.log(data);
  return new Promise((resolve, reject) => {
    axios.post(`dashboard/setUserSettings`, data)
      .then(response => resolve(response))
      .catch(error => reject(error))
  })
}